import location from '@/api/product/location-storage'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  is_not_assign_location: false,
  location_id: [],
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_IS_ASSIGN_LOCATION(state, data) {
    state.is_not_assign_location = data
  },
  SET_IS_LOCATION_ID(state, data) {
    state.location_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          is_not_assign_location: context.state.is_not_assign_location,
          location_id: context.state.location_id
        }
      },
      attrubutes
    )
    return location.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return location.store(data)
  },
  update(context, { id, data }) {
    return location.update(id, data)
  },
  destroy(context, id) {
    return location.destroy(id)
  },
  getLocation(context, attrubutes = {}) {
    return location.getLocation({ params: attrubutes })
  },
}